import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=489c3290&scoped=true"
import script from "./AlertBar.vue?vue&type=script&lang=js"
export * from "./AlertBar.vue?vue&type=script&lang=js"
import style0 from "./AlertBar.vue?vue&type=style&index=0&id=489c3290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c3290",
  null
  
)

export default component.exports